export default "__VITE_ASSET__8da2d98b__"